module.exports = __webpack_public_path__ + "static/media/ebitda-mgmt.44ec94ae.svg";